import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, AbstractControl, FormBuilder, Validators } from '@angular/forms';
//import { GeneralService } from '../../pages/Services/general.service';
import { GeneralService } from '../../Services/general.service'
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { formatDate } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PrimeNGConfig } from 'primeng/api';
import { FilterMatchMode } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { MenuService } from '../../../theme/components/menu/menu.service';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
declare var $;
@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss'],
  providers: [DatePipe, MenuService]
})
export class GroupsComponent implements OnInit {
  ModelTitle2: string;
  Component: string;
  ComponentName: any;
  Objective: any;
  Componentdata: any;
  cols2: { field: string; header: string; width: string; }[];
  ModelTitle1: string;
  cols1: { field: string; header: string; width: string; }[];
  selected: any;
  Description: any;
  ObjectName: any;
  Groups: any;
  Groups1: any;
  ObjectiveData: any;
  MenuId: any;
  GroupData: any;
  filteredValuesLength: any;
  Status: any;
  LoginDetails: any;
  ModelTitle: string;
  templateoriginal: any;
  template: any;
  flag: any;
  GroupName: any;
  cols: any;
  addNew: boolean;
  editForm: boolean;
  activitytype: any;
  Id: any;
  public form: FormGroup;
  Grid: boolean = true;
  myDate = new Date();
  todaydate: any;

  Pinned: boolean;
  PinId: any;
  MenuIdPin: any;
  public settings: Settings;
  currentPageRoute: any;
  constructor(public config: PrimeNGConfig, public menuService: MenuService, public appSettings: AppSettings, public router: Router, public toaster: ToastrService, public fb: FormBuilder, public route: ActivatedRoute, public generalService: GeneralService, private datePipe: DatePipe) {
    //this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.config.filterMatchModeOptions = {
      text: [
        FilterMatchMode.STARTS_WITH,
        FilterMatchMode.CONTAINS,
        FilterMatchMode.NOT_CONTAINS,
        FilterMatchMode.ENDS_WITH,
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
      ],
      numeric: [
        FilterMatchMode.EQUALS,
        FilterMatchMode.NOT_EQUALS,
        FilterMatchMode.LESS_THAN,
        FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        FilterMatchMode.GREATER_THAN,
        FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
      ],
      date: [
        FilterMatchMode.BEFORE,
        FilterMatchMode.AFTER,
      ]
    }
    this.MenuId = route.snapshot.params['Id'];
    this.todaydate = formatDate(this.myDate, 'yyyy-MM-dd hh:mm:ss a', 'en-US', '+0530');
    this.LoginDetails = JSON.parse(localStorage.getItem('LoginDetails'))
    this.form = this.fb.group({
      activitytype: ['', Validators.required]
    });

    this.settings = this.appSettings.settings;
    this.MenuIdPin = 0;
    this.router.events.subscribe((val) => {

      this.currentPageRoute = this.router.url; // Current page route

    });
  }

  ngOnInit(): void {
    /*For dropdowns*/
    this.GetPinned();
    this.getGroups();
    this.getGroupDetails();
    this.getObjectives();
    this.getComponentType();
    /*For Dropdowns*/
    this.getObjectiveDetails(); 
    //this.getCompanyType();
    if (this.MenuId == 1) {
      this.getGroups();
    }
    if (this.MenuId == 2) {
      this.getObjectives();
    }
    if (this.MenuId == 3) {
      this.getComponentType();
    }
  }
  handleChange(e) {
    var index = e.index;
    if (index == 0) {
      this.getGroups();
    }
    if (index == 1) {
      this.getObjectives();
    }
    if (index == 2) {
      this.getComponentType();

    }
  }
  Pined() {
    debugger
    this.Pinned = true;

    let Array = [];
    Array.push({
      MenuId: this.MenuIdPin, RouterLink: this.currentPageRoute, UserId: this.LoginDetails.logindetails.Id
    })
    var UploadFile = new FormData();
    UploadFile.append("Pinned", JSON.stringify(Array));
    var url = 'api/Values/AddPinned';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data == "SUCCESS") {
        debugger
        this.GetPinned();
        var UploadFile = new FormData();
        UploadFile.append("UserId", this.LoginDetails.logindetails.Id);
        //UploadFile.append("flag", '1');
        var url = 'api/Values/GetSideMenusWithRecentPinned';
        this.generalService.PostData(url, UploadFile).then((data1: any) => {
          debugger
          var Details = this.generalService.SIdeMenus(data1);
          this.menuService.RefreshMenu(Details, this.settings.theme.menu);
          debugger
        });

      }

    });
  }


  UnPin() {
    debugger

    var UploadFile = new FormData();
    UploadFile.append("PinId", this.PinId);
    UploadFile.append("UserId", this.LoginDetails.logindetails.Id);
    var url = 'api/Values/DeletePinned';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data == "SUCCESS") {
        debugger
        this.Pinned = false;
        var UploadFile = new FormData();
        UploadFile.append("UserId", this.LoginDetails.logindetails.Id);
        //UploadFile.append("flag", '1');
        var url = 'api/Values/GetSideMenusWithRecentPinned';
        this.generalService.PostData(url, UploadFile).then((data1: any) => {
          debugger
          var Details = this.generalService.SIdeMenus(data1);
          this.menuService.RefreshMenu(Details, this.settings.theme.menu);
          debugger
        });
      }
    });
  }

  GetPinned() {
    debugger
    var UploadFile = new FormData();
    UploadFile.append("MenuId", this.MenuIdPin);
    UploadFile.append("UserId", this.LoginDetails.logindetails.Id);
    UploadFile.append("RouterLink", this.currentPageRoute);

    var url = 'api/Values/GetPinned';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data.MSG == "EXISTS") {
        debugger
        this.PinId = data.PinId;
        this.Pinned = true;
      }
      else if (data.MSG == "NOT EXISTS") {
        this.Pinned = false;
      }
    });
  }
  //=======print====//
  onPrint() {
    window.print();
  }



  getGroups() {
    var url = "api/Master/GetGroupDetails";
    this.generalService.GetData(url).then((data: any) => {
      if (data != null) {
        var obj = Object.keys(data[0])
        this.cols = [
          { field: 'Id', header: 'Id', width: '150px' },
          { field: 'GroupName', header: 'ProjectStatus', width: '150px' },
          { field: 'Status', header: 'Status', width: '150px' },
          { field: 'CreatedDate', header: 'CreatedDate', width: '150px' },
          { field: 'CreateBy', header: 'CreatedBy', width: '150px' },
          { field: 'ModifiedDate', header: 'ModifiedDate', width: '150px' },
          { field: 'ModifiBy', header: 'ModifiedBy', width: '150px' },
        ]
        data.forEach(
          companyType => (companyType.CreatedDate = new Date(companyType.CreatedDate))
        );
        data.forEach(
          companyType => (companyType.ModifiedDate = new Date(companyType.ModifiedDate))
        );
        this.GroupData = data;
        this.templateoriginal = data;
      }
    }, err => {
      // this.spinner.hide();
      this.generalService.ShowAlert('ERROR', 'Something Went wrong', 'error');
    });
  }

  OpenAddForm() {

    this.ModelTitle = "Add ProjectStatus";
    $('#myModal').modal('show');
    this.Grid = false;
    this.GroupName = "";
    this.flag = "1";//for adding
    //this.addNew = true;
    //this.editForm = false;

  }

  TextBoxChange(item, key) {
    debugger
    let index: number = this.GroupData.findIndex(t => t.Id == item.Id);
    let index1: number = this.templateoriginal.findIndex(t => t.Id == item.Id);
    if (index > -1) {
      this.GroupData[index][key] = item[key];
      this.GroupName = this.GroupData[index].GroupName;
      this.Id = item.Id;
    }
    if (index1 > -1) {
      this.templateoriginal[index][key] = item[key];
      this.templateoriginal[index]['ModifiedBy'] = this.LoginDetails.logindetails.Id;
      this.templateoriginal[index]['ModifiedDate'] = this.todaydate;
    }
    // this.onRowUpadte();
    this.flag = "2"//for Update        
    var UploadFile = new FormData();
    UploadFile.append("GroupName", JSON.stringify(this.templateoriginal));
    UploadFile.append("flag", this.flag);
    var url = 'api/Master/UpdateDeleteGroups';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data != null) {
        this.getGroups();
        this.toaster.success('GroupName has been updated successfully', 'Success', {
          timeOut: 2000,
        });
        this.backform();
      }
    });
  }


  AddGroupName() {

    let Array = [];
    Array.push({
      GroupName: this.GroupName, CreatedBy: this.LoginDetails.logindetails.Id
    })
    var UploadFile = new FormData();
    UploadFile.append("Groups", JSON.stringify(Array));
    var url = 'api/Values/AddGroups';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      $('#myModal').modal('hide');
      this.getGroups();
      this.toaster.success('Group Name has been added successfully', 'Success', {
        timeOut: 2000,
      });
    });
  }

  onDelete(rowData) {
    Swal.fire({
      title: 'Are you sure to Delete  ?',
      //text: "",
      //type: 'warning',
      html: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      debugger
      if (result.value) {
        this.flag = "3";

        let Array = [];
        Array.push({
          GroupName: rowData.GroupName, Id: rowData.Id,
        })
        var UploadFile = new FormData();
        UploadFile.append("GroupName", JSON.stringify(Array));
        UploadFile.append("flag", this.flag);
        var url = 'api/Master/UpdateDeleteGroups';
        this.generalService.PostData(url, UploadFile).then((data: any) => {

          if (data == "success") {
            this.getGroups();
            this.generalService.ShowAlert('SUCCESS', 'GroupName has been Deleted successfully', 'success');
            this.backform();
          }
          else {
            this.generalService.ShowAlert('WARNING', 'You can not delete this record because of it is having relation with another table', 'warning');
            this.backform();
          }
        });
      }
    })
  }
  changeStatus(rowData, status) {
    this.Status = status;

    this.flag = "4";

    let Array = [];
    Array.push({
      Id: rowData.Id, Status: this.Status, ModifiedBy: this.LoginDetails.logindetails.Id, ModifiedDate: this.todaydate
    })
    var UploadFile = new FormData();
    UploadFile.append("GroupName", JSON.stringify(Array));
    UploadFile.append("flag", this.flag);
    var url = 'api/Master/UpdateDeleteGroups';
    this.generalService.PostData(url, UploadFile).then((data: any) => {

      if (data != null) {
        this.getGroups();
        if (this.Status == true) {
          this.toaster.success('Status Activated Successfully', 'Success', {
            timeOut: 2000,
          });
        }
        else {
          this.toaster.warning('Status Dectivated Successfully', 'Success', {
            timeOut: 2000,
          });
        }
      }
    });
  }

  backform() {
    ;
    this.Grid = true;
  }
  refresh() {
    location.reload();
  }

  /*Objective Management*/
  getObjectives() {
    var url = "api/Master/GetObjectiveDetails";
    this.generalService.GetData(url).then((data: any) => {
      debugger
      if (data != null) {
        var obj = Object.keys(data[0])
        this.cols1 = [
          { field: 'Id', header: 'Id', width: '150px' },
          { field: 'Objective', header: 'TaskType', width: '150px' },
          { field: 'GroupName', header: 'GroupName', width: '150px' },
          { field: 'Description', header:'Description',width:'150px'},
          { field: 'Status', header: 'Status', width: '150px' },
          { field: 'CreatedDate', header: 'CreatedDate', width: '150px' },
          { field: 'CreateBy', header: 'CreatedBy', width: '150px' },
          { field: 'ModifiedDate', header: 'ModifiedDate', width: '150px' },
          { field: 'ModifiBy', header: 'ModifiedBy', width: '150px' },
        ]
        data.forEach(
          dateType => (dateType.CreatedDate = new Date(dateType.CreatedDate))
        );
        data.forEach(
          dateType => (dateType.ModifiedDate = new Date(dateType.ModifiedDate))
        );
        this.ObjectiveData = data;
        this.templateoriginal = data;
      }
    }, err => {
      // this.spinner.hide();
      this.generalService.ShowAlert('ERROR', 'Something Went wrong', 'error');
    });
  }

  getGroupDetails() {

    var url = "api/Master/GetGroupDetails";
    this.generalService.GetData(url).then((data: any) => {
      if (data != null) {
        var obj = Object.keys(data[0])
        this.Groups1 = data;
      }
    }, err => {
      // this.spinner.hide();
      this.generalService.ShowAlert('ERROR', 'Something Went wrong', 'error');
    });
  }

  OpenAddForm1() {
    debugger
    this.ModelTitle1 = "Add TaskType";
    $('#myModal1').modal('show');
    this.Grid = false;
    this.ObjectName = "";
    this.Description = "";
    this.flag = "1";//for adding
    //this.addNew = true;
    //this.editForm = false;

  }

  TextBoxChange1(item, key) {
    debugger
    let index: number = this.ObjectiveData.findIndex(t => t.Id == item.Id);
    let index1: number = this.templateoriginal.findIndex(t => t.Id == item.Id);
    if (index > -1) {
      this.ObjectiveData[index][key] = item[key];
      this.ObjectiveData = this.ObjectiveData[index].TaskType;
      this.Id = item.Id;
    }
    if (index1 > -1) {
      this.templateoriginal[index][key] = item[key];
      this.templateoriginal[index]['ModifiedBy'] = this.LoginDetails.logindetails.Id;
      this.templateoriginal[index]['ModifiedDate'] = this.todaydate;
    }
    var UploadFile = new FormData();
    UploadFile.append("Objectives", JSON.stringify(this.templateoriginal));
    var url = 'api/Values/UpdateObjectives';
    this.generalService.PostData(url, UploadFile).then((data: any) => {

      this.ObjectiveData = '';
      if (data != null) {
        this.toaster.success('Objective has been updated successfully', 'Success', {
          timeOut: 2000,
        });
        this.backform();
        this.getObjectives();
      }
    });
  }

  AddObjective(Objective, selected, Descrition) {
    debugger
    let Array = [];
    Array.push({
      Objective: Objective,
      GroupId: selected,
      Description: Descrition,
      CreatedBy: this.LoginDetails.logindetails.Id
    })
    this.flag = '1';
    var UploadFile = new FormData();
    UploadFile.append("Objectives", JSON.stringify(Array));
    var url = 'api/Values/AddObjectives';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data != null) {
        $('#myModal1').modal('hide');
        this.getObjectives();
        this.toaster.success('Objectives has been added successfully', 'Success', {
          timeOut: 2000,
        });
        this.backform();
      }
    });
  }

  onDelete1(rowData) {
    debugger
    Swal.fire({
      title: 'Are you sure to Delete  ?',
      //text: "",
      //type: 'warning',
      html: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      debugger
      if (result.value) {        
        let Array = [];
        Array.push({
          Id: rowData.Id
        })
        var UploadFile = new FormData();
        UploadFile.append("Objectives", JSON.stringify(Array));
        var url = 'api/Values/DeleteObjectives';
        this.generalService.PostData(url, UploadFile).then((data: any) => {
          debugger
          if (data == "success") {
            this.getObjectives();
            this.generalService.ShowAlert('SUCCESS', 'Objective has been Deleted successfully', 'success');
            this.backform();
          }
          else {
            this.generalService.ShowAlert('WARNING', 'You can not delete this record because of it is having relation with another table', 'warning');
            this.backform();
          }
        });
      }
    })
  }

  changeStatus1(rowData, status) {
    this.Status = status;

    this.flag = "4";

    let Array = [];
    Array.push({
      Id: rowData.Id, Status: this.Status, ModifiedBy: this.LoginDetails.logindetails.Id, ModifiedDate: this.todaydate
    })
    this.Id = rowData.Id
    var UploadFile = new FormData();
    UploadFile.append("ObjectId", this.Id);
    UploadFile.append("Status", this.Status);
    var url = 'api/Values/ActiveandDeactiveonObjectives';
    this.generalService.PostData(url, UploadFile).then((data: any) => {

      if (data != null) {
        this.getObjectives();
        if (this.Status == true) {
          this.toaster.success('Status Activated Successfully', 'Success', {
            timeOut: 2000,
          });
        }
        else {
          this.toaster.warning('Status Dectivated Successfully', 'Success', {
            timeOut: 2000,
          });
        }
      }
    });
  }
  /*Component Details*/
  getComponentType() {

    var url = "api/Master/GetComponenteDetails";
    this.generalService.GetData(url).then((data: any) => {

      if (data != null) {
        var obj = Object.keys(data[0])
        this.cols2 = [
          { field: 'Id', header: 'Id', width: '150px' },
          { field: 'Status', header: 'Status', width: '150px' },
          { field: 'Component', header: 'Component', width: '150px' },
          { field: 'Objective', header: 'Objective', width: '150px' },
          { field: 'CreatedDate', header: 'CreatedDate', width: '150px' },
          { field: 'CreateBy', header: 'CreatedBy', width: '150px' },
          { field: 'ModifiedDate', header: 'ModifiedDate', width: '150px' },
          { field: 'ModifiBy', header: 'ModifiedBy', width: '150px' },
        ]
        data.forEach(
          dateType => (dateType.CreatedDate = new Date(dateType.CreatedDate))
        );
        data.forEach(
          dateType => (dateType.ModifiedDate = new Date(dateType.ModifiedDate))
        );
        this.Componentdata = data;
        this.templateoriginal = data;
      }
    }, err => {
      // this.spinner.hide();
      this.generalService.ShowAlert('ERROR', 'Something Went wrong', 'error');
    });
  }

  getObjectiveDetails() {
    var url = "api/Master/GetObjectiveDetails";
    this.generalService.GetData(url).then((data: any) => {
      console.log(data);
      if (data != null) {
        var obj = Object.keys(data[0])
        this.Objective = data;
      }
    }, err => {
      // this.spinner.hide();
      this.generalService.ShowAlert('ERROR', 'Something Went wrong', 'error');
    });
  }

  OpenAddForm2() {
    this.ModelTitle2 = "Add Component";
    $('#myModal2').modal('show');
    this.Grid = false;
    this.Component = "";
    this.flag = "1";//for adding
    //this.addNew = true;
    //this.editForm = false;
  }
  TextBoxChange2(item, key) {
    debugger
    let index: number = this.Componentdata.findIndex(t => t.Id == item.Id);
    let index1: number = this.templateoriginal.findIndex(t => t.Id == item.Id);
    if (index > -1) {
      this.Componentdata[index][key] = item[key];
      this.Componentdata = this.Componentdata[index].ActivityType;
      this.Id = item.Id;
    }
    if (index1 > -1) {
      this.templateoriginal[index][key] = item[key];
      this.templateoriginal[index]['ModifiedBy'] = this.LoginDetails.logindetails.Id;
      this.templateoriginal[index]['ModifiedDate'] = this.todaydate;
    }
    // this.onRowUpadte();
    this.flag = "2"//for Update        
    var UploadFile = new FormData();
    UploadFile.append("Component", JSON.stringify(this.templateoriginal));
    UploadFile.append("flag", this.flag);
    var url = 'api/Master/UpdateDeleteComponent';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data != null) {
        this.getComponentType();
        this.toaster.success('Component has been updated successfully', 'Success', {
          timeOut: 2000,
        });
        this.backform();
      }
    });
  }

  onDelete2(rowData) {
    Swal.fire({
      title: 'Are you sure to Delete  ?',
      //text: "",
      //type: 'warning',
      html: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      debugger
      if (result.value) {
        this.flag = "3";
        let Array = [];
        Array.push({
          Component: rowData.Component, Id: rowData.Id,
        })
        var UploadFile = new FormData();
        UploadFile.append("Component", JSON.stringify(Array));
        UploadFile.append("flag", this.flag);
        var url = 'api/Master/UpdateDeleteComponent';
        this.generalService.PostData(url, UploadFile).then((data: any) => {

          if (data == "success") {
            this.getComponentType();
            this.generalService.ShowAlert('SUCCESS', 'Component has been Deleted successfully', 'success');
            this.backform();
          }
          else {
            this.generalService.ShowAlert('WARNING', 'You can not delete this record because of it is having relation with another table', 'warning');
            this.backform();
          }
        });
      }
    })
  }
  changeStatus2(rowData, status) {
    this.Status = status;
    this.flag = "4";
    let Array = [];
    Array.push({
      Id: rowData.Id, Status: this.Status, ModifiedBy: this.LoginDetails.logindetails.Id, ModifiedDate: this.todaydate
    })
    var UploadFile = new FormData();
    UploadFile.append("Component", JSON.stringify(Array));
    UploadFile.append("flag", this.flag);
    var url = 'api/Master/UpdateDeleteComponent';
    this.generalService.PostData(url, UploadFile).then((data: any) => {

      if (data != null) {
        this.getComponentType();
        if (this.Status == true) {
          this.toaster.success('Status Activated Successfully', 'Success', {
            timeOut: 2000,
          });
        }
        else {
          this.toaster.warning('Status Dectivated Successfully', 'Success', {
            timeOut: 2000,
          });
        }
      }
    });
  }
  AddComponent(selected, ComponentName) {
    debugger
    let Array = [];
    Array.push({
      Component: ComponentName,
      ObjectiveId: selected,
      CreatedBy: this.LoginDetails.logindetails.Id
    })    
    this.flag = '1';
    var UploadFile = new FormData();
    UploadFile.append("Component", JSON.stringify(Array));
    UploadFile.append("flag", this.flag);
    var url = 'api/Master/UpdateDeleteComponent';
    this.generalService.PostData(url, UploadFile).then((data: any) => {
      debugger
      if (data != null) {
        $('#myModal2').modal('hide');
        this.getComponentType();
        this.toaster.success('Component has been added successfully', 'Success', {
          timeOut: 2000,
        });
        this.backform();
      }
    });
  }
}
